module.exports = __webpack_public_path__ + "static/media/orientacao.19a4caf3.svg";